import { render } from "./NamespaceList.vue?vue&type=template&id=3517cf75"
import script from "./NamespaceList.vue?vue&type=script&lang=js"
export * from "./NamespaceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__